export default {
  screens: [
    {
      type: 'intro',
      title: '可转换珠宝艺术',
      content:
        'Promenades Impériales“冬宫漫舞”系列，向俄罗斯艺术文化和西伯利亚雪域冰原致敬。尽显CHAUMET精湛技艺的珠宝杰作，可转换珠宝的创作艺术。以帕帕拉恰蓝宝石（Padparadscha ）点亮的这款项链线条简洁，拥有十种佩戴方式，可转换为胸针。',
      idYt: 'FAAhbyqO57o',
      videoCover: 'world/transformer/video.jpg',
      desktop: {
        cover: 'world/transformer/cover-1.jpg',
        introRight: 'world/transformer/introRight.jpg'
      },
      mobile: {
        cover: 'world/transformer/mobile-cover-1.jpg',
        contentStyle: { width: '92%' },
        coverStyle: {
          width: '34%',
          height: 'auto',
          top: '31.5vh',
          bottom: 'inherit',
          right: '-10px',
          left: 'inherit',
          position: 'absolute'
        },
        introRight: 'world/transformer/introRight.jpg'
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/transformer/memento.jpg',
      imgRight: 'world/transformer/mementoRight.jpg',
      mobile: {
        contentStyle: {
          width: '77.5%',
          left: '22.5%'
        }
      },
      content:
        '这一精湛工艺同样表现于“Trésors d’Afrique”非域珍藏高级珠宝套系中：Fourmis蚂蚁胸针可转换为一对耳环佩戴。'
    },
    {
      type: 'column',
      middleImg: 'world/transformer/columnMiddle.jpg',
      content:
        '以美轮美奂的祖母绿打造的这顶冠冕，来自约瑟芬皇后的直系后裔-洛伊希腾贝格家族。它给CHAUMET珍贵的动感花园带来无限生机。冠冕上的花叶装饰会随佩戴者的动作翩然若动，冠冕上的每朵花饰均可拆卸，作为发饰或者胸针佩戴。'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/transformer.js